// Constants
import { endDateOption, startDateOption } from "constants/searchPage/results";

interface LocationProductProps {
	location: string;
	startDate: string;
	endDate: string;
	productType: string;
}

const LocationProduct = ({ location, startDate, endDate, productType }: LocationProductProps) => {
	return (
		<div className="wk-place-date-wrapper">
			<div className="wk-place">{productType !== "0" ? location : "E-learning"}</div>
			{productType !== "22" && productType !== "0" && (
				<div className="wk-date">
					Dal {new Date(startDate).toLocaleDateString("it-IT", startDateOption)} al {new Date(endDate).toLocaleDateString("it-IT", endDateOption)}
				</div>
			)}
		</div>
	);
};

export default LocationProduct;
